// Filtering for the Find Clients page.
//
// Location is filtered server-side, so changing it reloads the page. Status and sort order are
// applied here: every listed inquiry is already on the page, so switching between statuses only
// shows and hides cards, and sorting only reorders them. Listeners are delegated from the
// document so they survive htmx swaps.

const ALL_INQUIRY_STATUSES = "all";

function filterInquiriesByStatus(selectedStatus) {
  let visibleInquiries = 0;

  document.querySelectorAll("[data-inquiry-card]").forEach((inquiryCard) => {
    const matchesStatus =
      selectedStatus === ALL_INQUIRY_STATUSES ||
      inquiryCard.dataset.inviteStatus === selectedStatus;

    inquiryCard.classList.toggle("hidden", !matchesStatus);

    if (matchesStatus) {
      visibleInquiries += 1;
    }
  });

  document.querySelectorAll("[data-find-clients-status-filter]").forEach((filterButton) => {
    const isSelected = filterButton.dataset.findClientsStatusFilter === selectedStatus;

    filterButton.classList.toggle("find-clients-status-filter--active", isSelected);
    filterButton.setAttribute("aria-pressed", isSelected.toString());
  });

  const noMatchesMessage = document.querySelector("#find-clients-no-matches");
  if (noMatchesMessage) {
    noMatchesMessage.classList.toggle("hidden", visibleInquiries > 0);
  }
}

// Cards arrive newest first; this reorders them in place by the time each inquiry was made.
function sortInquiries(sortOrder) {
  const inquiryList = document.querySelector("#find-clients-list");
  if (!inquiryList) {
    return;
  }

  const inquiryCards = Array.from(inquiryList.querySelectorAll("[data-inquiry-card]"));
  const direction = sortOrder === "oldest" ? 1 : -1;

  inquiryCards
    .sort((firstCard, secondCard) => direction * (Number(firstCard.dataset.createdAt) - Number(secondCard.dataset.createdAt)))
    .forEach((inquiryCard) => inquiryList.appendChild(inquiryCard));
}

document.addEventListener("click", function (event) {
  const filterButton = event.target.closest("[data-find-clients-status-filter]");
  if (!filterButton) {
    return;
  }

  filterInquiriesByStatus(filterButton.dataset.findClientsStatusFilter);
});

document.addEventListener("change", function (event) {
  const sortSelect = event.target.closest("[data-find-clients-sort]");
  if (sortSelect) {
    sortInquiries(sortSelect.value);
    return;
  }

  const locationFilterForm = event.target.closest("[data-find-clients-location-filter]");
  if (!locationFilterForm) {
    return;
  }

  locationFilterForm.submit();
});
